import { useQuery } from 'react-query';
import OrdersApi from '../../../../../OrdersApi';
import { getUserInfo } from '../../../../../../../telemetry/utils';
import { useTelemetryContext } from '../../../../../../../telemetry/telemetryContext';
import { AuthenticatedUser } from '../../../../../../../shared/types';
import * as ArchiveStatus from '../../../../../../../shared/ArchiveStatus';

type IArchiveQueryArgs = {
    orderId: number;
    user: AuthenticatedUser;
};

type IArchiveQueryResponse = {
    isPreArchived: boolean | null;
    isLoading: boolean;
};

export let archiveStatusQueryKey = 'customer-archive-status';

export function useArchiveCheckQuery({ orderId, user }: IArchiveQueryArgs): IArchiveQueryResponse {
    let { logger } = useTelemetryContext();

    let { data: archiveStatus, isLoading } = useQuery(
        [archiveStatusQueryKey, { orderId }],
        () => OrdersApi.checkIfOrderIsArchived(orderId),
        {
            useErrorBoundary: true,
            onError: (error) => {
                let additionalInfo = {
                    origin: 'CustomerImageProcessingPage.Query.checkIfOrderIsArchived',
                    userInfo: getUserInfo(user)
                };
                logger.logException(error, additionalInfo);
            }
        }
    );

    if (isLoading || !archiveStatus) {
        return { isPreArchived: null, isLoading: true };
    }

    let isPreArchived =
        archiveStatus.photoIsPreArchived &&
        archiveStatus.archivedStatus < ArchiveStatus.ArchivedGlacier;

    return {
        isPreArchived,
        isLoading: false
    };
}
